import React from "react";
import _ from "lodash";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Avatar from "@mui/material/Avatar";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import Badge from "@mui/material/Badge";
import StarIcon from "@mui/icons-material/Star";
import Flag from "react-world-flags";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import ApiCommonContent from "../../services/GenericContent";
import { styled } from "@mui/material/styles";
import "./styles.scss";
import { CommonContent, ContentKey } from "../../types/Types";

export type MyProfile = {
  name: string;
  avatar: string;
  position: number;
  points: number;
  ranking: number;
  country: string;
  countryCode: string;
};

export type Props = {
  profile: MyProfile;
  content:CommonContent[]
};

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 4px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "4px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

const MyProfile = (props: Props) => {
  const { profile } = props;
  return (
    <Box>
      <Stack direction="row" spacing={3} className="listHeaderProfile">
        <StyledBadge
          overlap="circular"
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          variant="dot"
        >
          <Avatar alt={profile.name} src={profile.avatar} className="listAvatarImg"/>
        </StyledBadge>
        <ListItemText primary={profile.name} className="listAvatarName" />
      </Stack>
      <List>
        <ListItem className="listItem">
          <ListItemText primary={ApiCommonContent.getKeyValue(
                props.content,
                ContentKey.SCORE
              )} className="listItemText"/>
          <Badge
            className="listBadge"
            badgeContent={profile.points}
            color="primary"
            max={9999}
          >
            <StarIcon className="listIcon"/>
          </Badge>
        </ListItem>
       
       
        <ListItem style={{display:'none'}} className="listItem">
          <ListItemText primary={ApiCommonContent.getKeyValue(
                props.content,
                ContentKey.BOARD_POSITIONS
              )} className="listItemText" />
          <div>
            <Typography variant="body2" className="listPosition">
              #{profile.position}
            </Typography>
          </div>
        </ListItem>
    
        <ListItem className="listItem">
          <ListItemText primary={ApiCommonContent.getKeyValue(
                props.content,
                ContentKey.GLOBAL_RANKING
              )} className="listItemText" />
          <div>
            <Typography variant="body2" className="listRanking">
              #{profile.ranking}
            </Typography>
          </div>
        </ListItem>

 
        <ListItem >
          <ListItemText primary={ApiCommonContent.getKeyValue(
                props.content,
                ContentKey.COUNTRY
              )}  className="listItemText" />
          <Stack direction="row" spacing={0}>
            <Flag className="profileFlag" code={profile.countryCode} />
            <ListItemText primary={profile.country} />
          </Stack>
        </ListItem>
      </List>
    </Box>
  );
};

export default MyProfile;
